import {
  Component,
  Input,
  ChangeDetectionStrategy,
  signal,
  viewChild,
  computed,

} from '@angular/core';
import { KeyValuePipe, NgComponentOutlet } from '@angular/common';
import { ZnButton } from '../zn-button/zn-button';
import { ZnPill } from '../zn-pill/zn-pill';
import { IModal } from './interfaces/IModal';
import { IModalContent } from './interfaces/IModalContent';
import { LocalizationPipe } from '@abp/ng.core';

@Component({
  selector: 'zn-modal-wrapper',
  standalone: true,
  imports: [
    ZnButton,
    ZnPill,
    NgComponentOutlet,
    LocalizationPipe,
    KeyValuePipe
  ],
  templateUrl: './zn-modal-wrapper.html',
  styleUrl: './zn-modal-wrapper.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZnModalWrapper {
  @Input() set configuration(value: IModal) {
    this._configuration.set(value);
  }

  @Input() set componentInputs(value: Record<string, any>) {
    this._componentInputs.set(value ?? {});
  }

  outlet = viewChild.required(NgComponentOutlet);

  protected _configuration = signal<IModal | undefined>(undefined);
  protected _componentInputs = signal<Record<string, any>>({})
  protected originalOrder = () => 0;

  protected loading = computed<boolean>(() => {
    const componentInstance = this.outlet().componentInstance as IModalContent;
    return componentInstance.loading?.() ?? false;
  });

  confirm(): void {
    this.outlet().componentInstance.confirm();
  }

  dismiss(): void {
    this.outlet().componentInstance.dismiss();
  }
}
